import { formatDate } from '@scripts/frontend/libs/utils/format-date'
import { formatPrice } from '@scripts/frontend/libs/utils/format-price'
import { __ } from '@wordpress/i18n'

import type { Order } from '../libs/type'

export type OrderMetaProps = {
  email: string
} & Pick<Order, 'createdDate' | 'paymentMethodTitle' | 'total'>

export function OrderMeta({
  createdDate,
  email,
  paymentMethodTitle,
  total,
}: Readonly<OrderMetaProps>) {
  return (
    <div className="[&amp;>*:not(:first-child)]:pl-0 [&amp;>*:not(:first-child)]:pt-6 md:[&amp;>*:not(:first-child)]:pl-10 md:[&amp;>*:not(:first-child)]:pt-0 grid space-y-6 divide-y md:flex md:justify-between md:space-x-10 md:space-y-0 md:divide-x md:divide-y-0">
      <div className="px-4">
        <h4 className="mb-2 font-medium">{__('Date', 'asavagroup')}</h4>
        {createdDate && <span>{formatDate(createdDate)}</span>}
      </div>
      <div className="px-4">
        <h4 className="mb-2 font-medium">{__('Email', 'asavagroup')}</h4>
        <span>{email}</span>
      </div>
      <div className="px-4">
        <h4 className="mb-2 font-medium">{__('Total', 'asavagroup')}</h4>
        <span>{formatPrice(total)}</span>
      </div>
      <div className="px-4">
        <h4 className="mb-2 font-medium">
          {__('Payment method', 'asavagroup')}
        </h4>
        <span>{paymentMethodTitle}</span>
      </div>
    </div>
  )
}

export default OrderMeta
